import { type QuestionTypeOption } from './dynamicDTOs';

export const questionTypes3: QuestionTypeOption[] = [
    {
        id: 21,
        key: 'addWordProblem',
        name: 'Add Word Problem',
        params: [
            {
                name: 'MaxSum',
                displayName: 'Max Sum',
                type: 'number',
                min: 1,
                max: 100000,
                default: 100,
            },
        ],
        subTypes: [
            {
                id: 1,
                name: 'result unknown',
            },
            {
                id: 2,
                name: 'change unknown',
            },
            {
                id: 3,
                name: 'start unknown',
            },
        ],
    },
    {
        id: 22,
        key: 'subWordProblem',
        name: 'Sub Word Problem',
        params: [
            {
                name: 'MaxSum',
                displayName: 'Max Sum',
                type: 'number',
                min: 30,
                max: 100000,
                default: 100,
            },
        ],
        subTypes: [
            {
                id: 1,
                name: 'result unknown',
            },
            {
                id: 2,
                name: 'change unknown',
            },
            {
                id: 3,
                name: 'start unknown',
            },
            {
                id: 4,
                name: 'difference unknown',
            },
            {
                id: 5,
                name: 'bigger unknown',
            },
            {
                id: 6,
                name: 'smaller unknown',
            },
        ],
    },
    {
        id: 23,
        key: 'additionArray',
        name: 'Addition Array',
        params: [
            {
                name: 'maxRows',
                displayName: 'Max Rows',
                type: 'number',
                min: 2,
                max: 10,
                default: 4,
            },
            {
                name: 'maxColumns',
                displayName: 'Max Columns',
                type: 'number',
                min: 2,
                max: 10,
                default: 3,
            },
        ],
        subTypes: [],
    },
];
